module.exports = __webpack_public_path__ + "img/portrait-053.0826b97f.jpg";